<template>
    <div class="articles">
        <h1>個別の夢診断一覧</h1>
        <div v-for="article in articles" :key="article.id">
          <p class="article_title"><router-link :to="{name:'case', params:{ id: article.params}}">{{article.title}}</router-link></p>
        </div>
        <!-- サイトマップ よう -->
        <!-- <div>
            <div v-for="article in articles" :key="article.id">
              &lt;url&gt;
              <br>&lt;loc&gt;
                https://dream.ameneko.com/article/{{article.title}}
                &lt;/loc&gt;   
              <br>&lt;/url&gt;
          </div>
        </div>  -->
    </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  data(){
    return{
      articles: [],
    }
  },
  watch: {
    '$route' (to) {
      this.$router.go(to.params.id)
    }
  },
  mounted() {
    this.fetchNotice();
    const title = "夢解釈の一覧｜夢占い辞典ゆめみん"
    const description = "夢占い辞典ゆめみんの夢解釈の一覧です"
    const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
    const og_image = 'https://dream.ameneko.com/topImage.jpeg'
    document.title = title
    document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
    document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
},
  methods: {
    fetchNotice() {
        axios.get("https://dream.microcms.io/api/v1/case?limit=10000", {
          headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
        }).then(res => {
          this.articles = res.data.contents;
        }).catch(err => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.articles{
  max-width: 500px;
  margin: auto;
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
.article_title{
  font-size: 1.2em;
  padding:6px;
}
.next-page{
  padding:20px 0 20px 0;
  font-size: 1.2em;
}
</style>